import { ArpFields } from "constants/forecasts.constants";

import { ExtendSegment } from "../utils/ExtendSegment";
import { InitialSegment } from "../utils/InitialSegment";
import { UpdateSegment } from "../utils/updateSegment";

/**
 * Enum mapping template names to their database type identifiers.
 * These values correspond to the `type` field in the templates collection.
 */
export enum TemplateType {
  OneSegment = 1,
  TwoSegment = 2,
  TwoSegmentWithRampUp = 3,
  ThreeSegment = 4,
  ThreeSegmentWithRampUp = 5,
  ThreeSegmentWithConstrainedPeriod = 6,
  SAGD = 7
}

export interface ProductData {
  "Start Date": string;
  Q0?: number;
  Bcons?: number;
  tCons?: number;
  Qi?: number;
  Di?: number;
  B?: number;
  Btrans?: number;
  Bhyp?: number;
  Bf?: number;
  tRamp?: number;
  tTrans?: number;
  tFlat?: number;
  Df?: number;
  Qf?: number;
  [ArpFields.EUR]?: string;
  CTD?: number;
  TotalEUR?: string;
  [ArpFields.RestrictedEUR]?: string;
}

export interface SegmentTemplate {
  type: number;
  name: string;
  numberOfSegments: number;
  productCols: string[];
  productDisplayData: unknown[];
  rowHeaders: string[];
  displayHeaders: string[];
  update: UpdateSegment;
  initialData: InitialSegment;
  extendArps: ExtendSegment;
}

export interface ProductSegmentTemplate {
  [product: string]: SegmentTemplate;
}

export interface TypeWellTemplate {
  id: string;
  type: number;
  name: string;
  numberOfSegments: number;
  headers: TypeWellTemplateHeader[];
  order: number;
}

export interface TypeWellTemplateHeader {
  name: string;
  displayName: string;
}
